import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
// import Footer from "../../layout/Footer/Footer";
import {
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  ButtonGroup,
  Col,
} from "reactstrap";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import { encode } from "base64-arraybuffer";
import axios from "axios";
import Baja from "../../Baja";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import { v4 as uuidv4 } from "uuid";

function ListadoLotes() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_INVENTARIOS = `${process.env.REACT_APP_URL_INVENTARIOS}`;
  const URL_SEGUIMIENTOS = `${process.env.REACT_APP_URL_SEGUIMIENTOS}`;
  const URL_ARTICULOS = process.env.REACT_APP_URL_ARTICULOS;
  const URL_SEND_MAIL_ATT = process.env.REACT_APP_URL_SEND_MAIL_ATT;
  const URL_ARTICULOS_PEDIDO = process.env.REACT_APP_URL_ARTICULOS_PEDIDO;

  const [inventarios, setInventarios] = useState([]);

  const [articulos, setArticulos] = useState([]);
  const [selectedArticulo, setSelectedArticulo] = useState("");
  const [total_cantidad_anterior, setTotalCantidadAnterior] = useState(0);
  const [total_cantidad_nueva, setTotalCantidadNueva] = useState(0);

  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);
  const [mailTo, setMailTo] = useState("");

  //--- Pagination
  const [comments, setComments] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const ITEMS_PER_PAGE = 50;

  const [comments2, setComments2] = useState([]);
  const [movimientos, setMovimientos] = useState([]);

  const [validaBoton, setValidaBoton] = useState(true);

  useEffect(() => {
    axios
      .get(URL_ARTICULOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allArticulos = response.data;
        setArticulos(allArticulos);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  function BuscaArticulo(event) {
    setSelectedArticulo(event.target.value);
    // Jala Inventario
    axios
      .get(`${URL_INVENTARIOS}Lotes/${event.target.value}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allDisponible = response.data;
        setComments(allDisponible);
        setInventarios(allDisponible);

        let cant = allDisponible.map((c) => parseFloat(c.cantidadAnterior));
        let TC = cant.reduce((t, total, index) => t + total, 0);
        setTotalCantidadAnterior(TC);
        setTotalCantidadNueva(TC);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  function PDFTabla() {
    let total_cantidad = 0;
    let total_cajas = 0;
    const data = inventarios.map((a) => {
      total_cantidad = total_cantidad + a.cantidad;
      total_cajas = total_cajas + a.cantidad / a.piezasPorCaja;
      return [
        a.SKU,
        a.nombre,
        a.piezasPorCaja,
        new Intl.NumberFormat("en-US").format(
          (a.cajas).toFixed(2)
        ),
        new Intl.NumberFormat("en-US").format(a.cantidadNueva),
        a.lote,
      ];
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape", "mm", "a4", true);
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 230, 30, 45, 15);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 120, 10, 45, 30);
    doc.text(`Listado Lotes`, 20, 40);
    doc.autoTable({
      head: [
        [
          "SKU",
          "Nombre",
          "PxC",
          "Cajas",
          "Cantidad",
          "Lote",
        ],
      ],
      body: dataPDFLimpia,
      startY: 45,
      // footStyles: {
          //   fontSize: 12,
          //   fillColor: [255,255,255],
          //   textColor: [0,0,0]
          // },
          // foot: [
      //   [
      //     "",
      //     "",
      //     "Total",
      //     new Intl.NumberFormat("en-US").format(total_cajas.toFixed(2)),
      //     new Intl.NumberFormat("en-US").format(total_cantidad),
      //   ],
      // ],
      showFoot: "lastPage",
    });
    doc.save(`Lotes.pdf`);
  }

  function excel() {
    const dataExcel = inventarios.map((a) => {
      return {
        SKU: a.SKU,
        Nombre: a.nombre,
        PiezasPorCaja: a.piezasPorCaja,
        Cajas: (a.cantidad / a.piezasPorCaja).toFixed(2),
        Cantidad: a.cantidad,
        Almacen: a.area,
        Lote: a.lote,
      };
    });
    const dataExportExcel = Object.values(dataExcel);
    const dataExcelLimpia = dataExportExcel.filter(function (el) {
      return el != null;
    });

    var option = {};

    option.fileName = "ListadoLotes";

    option.datas = [
      {
        sheetData: dataExcelLimpia,
        sheetName: "ListadoLotes",
        sheetFilter: [
          "SKU",
          "Nombre",
          "PiezasPorCaja",
          "Cajas",
          "Cantidad",
          "Almacen",
          "Lote",
        ],
        sheetHeader: [
          "SKU",
          "Nombre",
          "PiezasPorCaja",
          "Cajas",
          "Cantidad",
          "Almacen",
          "Lote",
        ],
      },
    ];

    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

  function enviaMail() {
    let total_cantidad = 0;
    let total_cajas = 0;
    const data = inventarios.map((a) => {
      total_cantidad = total_cantidad + a.cantidad;
      total_cajas = total_cajas + a.cantidad / a.piezasPorCaja;
      return [
        a.SKU,
        a.nombre,
        a.piezasPorCaja,
        new Intl.NumberFormat("en-US").format(
          (a.cantidad / a.piezasPorCaja).toFixed(2)
        ),
        new Intl.NumberFormat("en-US").format(a.cantidad),
        a.area,
        a.lote,
      ];
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape", "mm", "a4", true);
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 230, 30, 45, 15);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 120, 10, 45, 30);
    doc.text(`Listado Lotes`, 20, 40);
    doc.autoTable({
      head: [
        [
          "SKU",
          "Nombre",
          "PxC",
          "Cajas",
          "Cantidad",
          "Almacen",
          "Lote",
        ],
      ],
      body: dataPDFLimpia,
      startY: 45,
      footStyles: {
            fontSize: 12,
            fillColor: [255,255,255],
            textColor: [0,0,0]
          },
          foot: [
        [
          "",
          "",
          "Total",
          new Intl.NumberFormat("en-US").format(total_cajas.toFixed(2)),
          new Intl.NumberFormat("en-US").format(total_cantidad),
        ],
      ],
      showFoot: "lastPage",
    });
    var att = doc.output("arraybuffer");
    var base64File = encode(att);

    // Envia el Mail
    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: "Listado Seguimiento",
          email: mailTo,
          fileName: "ListadoLotes.pdf",
          att: base64File,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
         <th><img width="${process.env.REACT_APP_TAMANO_LOGO_MAIL}" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}logoInstitucion.png" /></th>
         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${process.env.REACT_APP_NOMBRE_INSTITUCION}</tr>
         <tbody>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras el listado de Disponibles.</tr>
         </tbody>
         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${process.env.REACT_APP_TELEFONO_INSTITUCION}</tr>
         <tr align="right"><br>Powered by <a href="https://lynqro.com"> <img width="20%" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}Logo-Lynqro-PDF.png" /> </a> </tr>
         </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        toggleMail();
        Swal.fire("Good job!", "Enviado con exito", "success");
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

  const headers = [
    { name: "SKU", field: "SKU", sortable: true },
    { name: "Nombre", field: "nombre", sortable: true },
    { name: "Piezas por Caja", field: "piezasPorCaja", sortable: true },
    // { name: "Cajas", field: "cajas", sortable: true },
    { name: "Cantidad", field: "cantidad", sortable: true },
    // { name: "Almacen", field: "area", sortable: true },
    { name: "Lote", field: "lote", sortable: true },
  ];

  const commentsData = useMemo(() => {
    let computedComments = comments;

    if (search) {
      computedComments = computedComments.filter(
        (comment) =>
          comment.SKU.toLowerCase().includes(search.toLowerCase()) ||
          comment.nombre.toLowerCase().includes(search.toLowerCase()) ||
          comment.area.toLowerCase().includes(search.toLowerCase()) ||
          comment.lote.toLowerCase().includes(search.toLowerCase()) ||
          comment.piezasPorCaja.toString().includes(search) ||
          comment.cajas.toString().includes(search) ||
          comment.cantidad.toString().includes(search)
      );
    }

    setTotalItems(computedComments.length);

    //Sorting comments
    if (
      sorting.field &&
      sorting.field != "cantidad" &&
      sorting.field != "piezasPorCaja" &&
      sorting.field != "cajas"
    ) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])
      );
    }

    if (
      sorting.field &&
      sorting.order === "asc" &&
      (sorting.field == "cantidad" ||
        sorting.field == "piezasPorCaja" ||
        sorting.field == "cajas")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) > parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    if (
      sorting.field &&
      sorting.order === "desc" &&
      (sorting.field == "cantidad" ||
        sorting.field == "piezasPorCaja" ||
        sorting.field == "cajas")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) < parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [comments, currentPage, search, sorting]);

  function saveLote(event) {
    event.preventDefault();
    if (inventarios.filter((e) => e.lote == "").length > 0) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Debes Capturar la lote!",
        showConfirmButton: false,
      });
    } else {
      if (total_cantidad_nueva == total_cantidad_anterior) {
        let totalLote = inventarios.length;
        inventarios.map((a) => {
          axios
            .patch(
              `${URL_INVENTARIOS}Lote`,
              {
                articulos: a.idArticulo,
                cantidad:
                  parseFloat(a.cantidadNueva) - parseFloat(a.cantidadAnterior),
                lote: a.lote,
              },
              {
                headers: {
                  Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                },
              }
            )
            .then(() => {
              totalLote = totalLote - 1;
              if (totalLote == 0) {
                axios
                  .post(
                    URL_LOGS,
                    {
                      tipo: "Cambio de Lote",
                      detalle: `Modelo ${selectedArticulo}`,
                      user: user.id,
                    },
                    {
                      headers: {
                        Authorization: `Bearer: ${localStorage.getItem(
                          "app_token"
                        )}`,
                      },
                    }
                  )
                  .then(() => {
                    Swal.fire("Good job!", "Guardado con exito", "success");
                    setTimeout(() => {
                      window.location.reload();
                    }, 1000);
                  })
                  .catch((error) => {
                    Swal.fire({
                      icon: "error",
                      title: "Oops...",
                      text: "Something went wrong!",
                      footer: `${error.response.data}`,
                    });
                    console.log(error);
                    setValidaBoton(true);
                  });
              }
            })
            .catch((error) => {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Something went wrong!",
                footer: `${error.response.data}`,
              });
              console.log(error);
            });
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: `La cantidad del inventario ${total_cantidad_anterior} es diferente de la cantidad registrada ${total_cantidad_nueva}`,
        });
      }
    }
  }
  const handleAddFields = () => {
    const ultimo = inventarios[inventarios.length - 1];

    setInventarios([
      ...inventarios,
      {
        id: uuidv4(),
        activo: "Si",
        idArticulo: ultimo.idArticulo,
        SKU: ultimo.SKU,
        nombre: ultimo.nombre,
        cantidadAnterior: 0,
        cantidadNueva: 0,
        cajas: 0,
        piezasPorCaja: ultimo.piezasPorCaja,
        cajas: 0,
        lote: "",
      },
    ]);
  };

  function ActualizaTotales() {
    let cant = inventarios.map((c) => parseFloat(c.cantidadNueva));
    let TC = cant.reduce((t, total, index) => t + total, 0);
    setTotalCantidadNueva(TC);
  }

  const handleChangeInputCantidad = (id, event) => {
    if (event.target.value >= 0) {
      const newInventarios = inventarios.map((i) => {
        if (id === i._id) {
          i[event.target.name] = event.target.value;
          i.cajas =
            parseFloat(event.target.value) / parseFloat(i.piezasPorCaja);
        }
        return i;
      });
      setInventarios(newInventarios);
      ActualizaTotales();
    }
  };

  // const handleChangeInputCaja = (id, event) => {
  //   if (event.target.value >= 0) {
  //     const newInventarios = inventarios.map((i) => {
  //       if (id === i._id) {
  //         i[event.target.name] = event.target.value;
  //         i.cantidadNueva = parseFloat(i.cajas) * parseFloat(i.piezasPorCaja);
  //       }
  //       return i;
  //     });
  //     setInventarios(newInventarios);
  //     ActualizaTotales();
  //   }
  // };

  const handleChangeInputLote = (id, event) => {
    if (
      inventarios.filter((e) => e.lote == event.target.value).length > 0
    ) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "La lote ya existe!",
        showConfirmButton: false,
      });
      const newInventarios = inventarios.map((i) => {
        if (id === i.id) {
          i.articulos = "";
        }
        return i;
      });
      setInventarios(newInventarios);
    } else {
      const newInventarios = inventarios.map((i) => {
        if (id === i._id) {
          i[event.target.name] = event.target.value;
        }
        return i;
      });
      setInventarios(newInventarios);
      ActualizaTotales();
    }
  };

  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_inventarios ? (
        <div className="card col-12">
          <Row>
            <Col md={8}>
              <Button
                size="sm"
                href="/MenuInventarios"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button>
            </Col>
            <Col sm={4}>
              <ButtonGroup id="logoutBoton">
                <Button
                  size="sm"
                  className="btn"
                  color="danger"
                  onClick={PDFTabla}
                >
                  PDF <i class="far fa-file-pdf"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  onClick={toggleMail}
                  color="info"
                >
                  eMail <i class="fas fa-at"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  color="primary"
                  onClick={excel}
                >
                  Excel <i class="far fa-file-excel"></i>
                </Button>
              </ButtonGroup>
            </Col>
          </Row>
          <Modal size="sm" isOpen={modalMail} toggle={toggleMail}>
            <ModalHeader toggle={toggleMail}>
              <h4>Enviar Listado Disponible</h4>
            </ModalHeader>
            <ModalBody>
              <Label className="mr-sm-2">Email</Label>
              <Input
                className="col-sm-12"
                type="text"
                value={mailTo}
                required
                onChange={(e) => {
                  setMailTo(e.target.value);
                }}
              />
            </ModalBody>
            <ModalFooter>
              <Button size="sm" color="success" onClick={enviaMail}>
                Enviar
              </Button>
            </ModalFooter>
          </Modal>

          <h3 align="center">Lotes en CEDIS</h3>
          <div className="row">
            <div className="col-md-2">
              <Label>Codigo QR</Label>
            </div>
            <div className="col-md-2">
              <Label>SKU</Label>
            </div>
            <div className="col-md-2">
              <Label>Modelo</Label>
            </div>
          </div>
          <div className="row">
            <div className="col-md-2">
              <Input
                bsSize="sm"
                type="text"
                value={selectedArticulo}
                onChange={(e) => {
                  BuscaArticulo(e);
                  setCurrentPage(1);
                }}
              ></Input>
            </div>
            <div className="col-md-2">
              <Input
                bsSize="sm"
                type="select"
                value={selectedArticulo}
                onChange={(e) => {
                  BuscaArticulo(e);
                  setCurrentPage(1);
                }}
              >
                <option value="">Selecciona</option>
                {articulos
                  .sort((a, b) => (a.SKU > b.SKU ? 1 : -1))
                  .map((a) => {
                    return <option value={a._id}>{a.SKU} </option>;
                  })}
              </Input>
            </div>

            <div className="col-md-2">
              <Input
                bsSize="sm"
                type="select"
                value={selectedArticulo}
                onChange={(e) => {
                  BuscaArticulo(e);
                  setCurrentPage(1);
                }}
              >
                <option value="">Selecciona</option>
                {articulos
                  .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
                  .map((a) => {
                    return <option value={a._id}>{a.nombre} </option>;
                  })}
              </Input>
            </div>
          </div>
          <br />
          {inventarios.length > 0 ? (
            <>
              <Table
                size="sm"
                striped
                borderless
                className="table-responsive-xl"
              >
                <TableHeader
                  headers={headers}
                  onSorting={(field, order) => setSorting({ field, order })}
                />

                <tbody>
                  {inventarios.map((ao) => {
                    return (
                      <tr key={ao._id}>
                        <td>{ao.SKU}</td>
                        <td>{ao.nombre}</td>
                        <td>{ao.piezasPorCaja}</td>
                        {/* <td>
                          <Input
                            bsSize="sm"
                            name="cajas"
                            type="number"
                            min="0"
                            step="any"
                            placeholder="Cajas"
                            value={ao.cajas}
                            onChange={(event) =>
                              handleChangeInputCaja(ao._id, event)
                            }
                          />
                        </td> */}
                        <td>
                          <Input
                            bsSize="sm"
                            name="cantidadNueva"
                            type="number"
                            min="0"
                            step="any"
                            placeholder="Cantidad"
                            value={ao.cantidadNueva}
                            required
                            onChange={(event) =>
                              handleChangeInputCantidad(ao._id, event)
                            }
                          />
                        </td>

                        <td>
                          {ao.cantidadAnterior > 0 ? (
                            ao.lote
                          ) : (
                            <Input
                              bsSize="sm"
                              name="lote"
                              type="text"
                              placeholder="Lote"
                              value={ao.lote}
                              onChange={(event) =>
                                handleChangeInputLote(ao._id, event)
                              }
                            />
                          )}
                        </td>
                        <td>
                          <Button
                            size="sm"
                            className="btn"
                            color="info"
                            onClick={handleAddFields}
                            tabindex="-1"
                          >
                            <i class="fas fa-plus"></i>
                          </Button>
                        </td>
                      </tr>
                    );
                  })}
                  <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td td className="negrita" align="center">
                      Total
                    </td>
                    <td td className="negrita">
                      {total_cantidad_nueva}
                    </td>
                    <td></td>
                    <td></td>
                  </tr>
                </tbody>
              </Table>
              <Row>
                <Col>
                  {validaBoton && selectedArticulo != "" ? (
                    <Button
                      type="submit"
                      size="sm"
                      className="btn"
                      color="info"
                      tabindex="-1"
                      onClick={saveLote}
                      id="logoutBoton"
                    >
                      Guardar
                    </Button>
                  ) : undefined}
                </Col>
              </Row>
            </>
          ) : (
            <h4>No se encontraron Movimientos....</h4>
          )}
        </div>
      ) : undefined}

      {loader}
    </>
  );
}

export default ListadoLotes;
